<hb-modal-dialog [heading]="orgTreeNodeName ? ('InspectionHistory.InspectionHistory' | i18next) + ' - ' + orgTreeNodeName : 'InspectionHistory.InspectionHistory' | i18next" [showCancel]="false">
  <p-table #inspectionTable class="data-display-table" [columns]="cols" [value]="reports" [paginator]="true" [rows]="10" content>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th scope="col" *ngFor="let col of columns" [pSortableColumn]="col.field">
          {{col.header}}
          <p-sortIcon [field]="col.field" ariaLabel="Sort" ariaLabelDesc="{{'InspectionHistory.DialogSortDescending' | i18next}}"
            ariaLabelAsc="{{'InspectionHistory.DialogSortAscending' | i18next}}">
          </p-sortIcon>
        </th>
      </tr>
      <tr>
        <th scope="col" *ngFor="let col of columns">
          <input *ngIf="reports && reports.length > 0" pInputText type="text"
            (input)="inspectionTable.filter($event.target.value, col.field, col.filterMatchMode)">
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-report let-columns="columns">
      <tr>
        <td *ngFor="let col of columns" [ngSwitch]="col.field">
          <div *ngSwitchCase="'description'">{{getDescription(report, report[col.field])}}</div>
          <div *ngSwitchCase="'discriminator'">{{getDiscriminator(report[col.field])}}</div>
          <div *ngSwitchCase="'inspectionDate'">{{report[col.field] | dateTimeFormatter}}</div>
          <div *ngSwitchDefault>{{report[col.field]}}</div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length">
          {{'InspectionHistory.NoReportsFound' | i18next}}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="paginatorright" let-state>
      <div class="paginator-text">
        {{'InspectionHistory.InspectionCount' | i18next}} : {{state.totalRecords}}
      </div>
    </ng-template>
  </p-table>
</hb-modal-dialog>
